import React, { useState, useEffect, useRef, useContext } from "react";
import { Result } from "antd";
import { AuthContext } from "../../../context/AuthContext";
import { useAlert } from "../../../context/AlertProvider";
import UserInitialsAvatar from "./UserInitialsAvatar";
import { postAuthMethod } from "../../../services/HttpServices";
import {
  Avatar,
  Button,
  Input,
  Modal,
  Select,
  message,
  Dropdown,
  Menu,
  Tooltip,
  Alert,
  Popover,
} from "antd";
import {
  LinkOutlined,
  RobotOutlined,
  SendOutlined,
  SmileOutlined,
  FileTextOutlined,
  CheckCircleFilled,
  DeleteOutlined,
  DownOutlined,
  VideoCameraOutlined,
  AudioOutlined,
  FileOutlined,
  DownloadOutlined,
  WarningOutlined,
  FileExclamationOutlined,
  CloseOutlined,
  ClockCircleOutlined,
  LockOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import botMascot from "../../../assets/images/bot_mascot.png";
import { getChatWindowDateLabel } from "../../../utils";
import moment from "moment";
import TemplatePreview from "../template-composer/TemplatePreview";
import MediaPickerModal from "../MediaPickerModal";

const { Option } = Select;

const EMOJI_CATEGORIES = [
  {
    key: "popular",
    label: "🔥 Popular",
    emojis: [
      "😊",
      "😂",
      "❤️",
      "👍",
      "🔥",
      "🙏",
      "😍",
      "🎉",
      "✨",
      "🥰",
      "👌",
      "🙌",
      "💯",
      "😎",
      "🚀",
      "⚡",
      "🤝",
      "🏨",
      "📅",
      "💼",
    ],
  },
  {
    key: "smileys",
    label: "😊 Smileys",
    emojis: [
      "😀",
      "😃",
      "😄",
      "😁",
      "😆",
      "😅",
      "🤣",
      "😂",
      "🙂",
      "🙃",
      "😉",
      "😊",
      "😇",
      "🥰",
      "😍",
      "🤩",
      "😘",
      "😗",
      "😚",
      "😋",
      "😛",
      "😜",
      "🤪",
      "😝",
      "🤑",
      "🤗",
      "🤭",
      "🤫",
      "🤔",
      "🤐",
      "🤨",
      "😐",
      "😑",
      "😶",
      "😏",
      "😒",
      "🙄",
      "😬",
      "🤥",
      "😌",
      "😔",
      "😪",
      "🤤",
      "😴",
      "😷",
      "🤒",
      "🤕",
      "🤢",
      "🤮",
      "🤧",
      "🥵",
      "🥶",
      "🥴",
      "😵",
      "🤯",
      "🤠",
      "🥳",
      "😎",
      "🤓",
      "🧐",
    ],
  },
  {
    key: "gestures",
    label: "👍 Gestures",
    emojis: [
      "👋",
      "🤚",
      "🖐️",
      "✋",
      "🖖",
      "👌",
      "🤌",
      "🤏",
      "✌️",
      "🤞",
      "🤟",
      "🤘",
      "🤙",
      "👈",
      "👉",
      "👆",
      "🖕",
      "👇",
      "☝️",
      "👍",
      "👎",
      "✊",
      "👊",
      "🤛",
      "🤜",
      "👏",
      "🙌",
      "👐",
      "🤲",
      "🤝",
      "🙏",
      "✍️",
      "💅",
      "🤳",
      "💪",
      "🧠",
    ],
  },
  {
    key: "symbols",
    label: "❤️ Hearts & Symbols",
    emojis: [
      "❤️",
      "🧡",
      "💛",
      "💚",
      "💙",
      "💜",
      "🖤",
      "🤍",
      "🤎",
      "💔",
      "❣️",
      "💕",
      "💞",
      "💓",
      "💗",
      "💖",
      "💘",
      "💝",
      "💟",
      "⭐",
      "🌟",
      "✨",
      "⚡",
      "🔥",
      "💥",
      "💯",
      "⭕",
      "❌",
      "❓",
      "❗",
      "✔️",
      "✅",
      "⚠️",
      "🚩",
      "🔔",
      "📢",
    ],
  },
  {
    key: "business",
    label: "🏨 Business",
    emojis: [
      "🏨",
      "💼",
      "🏢",
      "📅",
      "📊",
      "📈",
      "📉",
      "📄",
      "📝",
      "📞",
      "✉️",
      "📧",
      "📥",
      "📤",
      "✈️",
      "🚀",
      "🗺️",
      "🛎️",
      "🔑",
      "💳",
      "💰",
      "💵",
      "🎯",
      "🏷️",
      "⭐",
      "🌐",
      "🔔",
      "⏰",
      "⏱️",
      "⏳",
    ],
  },
];

const EmojiPickerContent = ({ onSelectEmoji }) => {
  const [activeCategory, setActiveCategory] = useState("popular");
  const [searchQuery, setSearchQuery] = useState("");

  const currentCategory =
    EMOJI_CATEGORIES.find((c) => c.key === activeCategory) ||
    EMOJI_CATEGORIES[0];

  const filteredEmojis = searchQuery.trim()
    ? EMOJI_CATEGORIES.flatMap((c) => c.emojis).filter(
        (emoji, index, self) => self.indexOf(emoji) === index,
      )
    : currentCategory.emojis;

  return (
    <div className="tw-w-[280px] tw-p-1 tw-font-sans">
      <div className="tw-mb-2">
        <Input
          placeholder="Search emojis..."
          size="small"
          allowClear
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="tw-rounded-md tw-text-xs"
        />
      </div>

      {!searchQuery && (
        <div className="tw-flex tw-gap-1 tw-mb-2 tw-overflow-x-auto tw-pb-1 tw-border-b tw-border-solid tw-border-gray-100 sleek-scrollbar">
          {EMOJI_CATEGORIES.map((cat) => (
            <button
              key={cat.key}
              type="button"
              onClick={() => setActiveCategory(cat.key)}
              className={`tw-px-2 tw-py-1 tw-text-[11px] tw-font-medium tw-rounded-md tw-whitespace-nowrap tw-border-none tw-cursor-pointer tw-transition-colors ${
                activeCategory === cat.key
                  ? "tw-bg-[#25D366] tw-text-white"
                  : "tw-bg-gray-100 tw-text-gray-600 hover:tw-bg-gray-200"
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>
      )}

      <div className="tw-grid tw-grid-cols-7 tw-gap-1 tw-max-h-[190px] tw-overflow-y-auto tw-p-1 sleek-scrollbar">
        {filteredEmojis.map((emoji, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => onSelectEmoji(emoji)}
            className="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-text-lg tw-rounded-lg hover:tw-bg-gray-100 tw-transition-colors tw-border-none tw-bg-transparent tw-cursor-pointer hover:tw-scale-110"
          >
            {emoji}
          </button>
        ))}
      </div>
    </div>
  );
};

const computeSampleValues = (template, mappings, activeChat) => {
  if (!template) return { header: {}, body: {} };

  const getVarVal = (mapping, defaultLabel) => {
    if (!mapping) return defaultLabel;
    if (mapping.isDynamic) {
      if (mapping.attribute && activeChat) {
        const val =
          activeChat[mapping.attribute] ||
          activeChat?.lead?.[mapping.attribute] ||
          activeChat?.contact?.[mapping.attribute];
        if (val) return String(val);
      }
      return `[${mapping.attribute || "Property"}]`;
    }
    return mapping.value || defaultLabel;
  };

  const sampleHeader = {};
  if (mappings?.header) {
    Object.keys(mappings.header).forEach((v) => {
      sampleHeader[v] = getVarVal(mappings.header[v], `[Header Var ${v}]`);
    });
  }

  const sampleBody = {};
  if (mappings?.body) {
    Object.keys(mappings.body).forEach((v) => {
      sampleBody[v] = getVarVal(mappings.body[v], `[Var ${v}]`);
    });
  }

  return { header: sampleHeader, body: sampleBody };
};

const getTemplateBodyText = (template) => {
  if (!template) return "";
  if (template.bodyText) return template.bodyText;
  if (template.body) return template.body;
  if (template.content) return template.content;
  if (template.text) return template.text;
  if (template.message) return template.message;

  let comps = template.components;
  if (typeof comps === "string") {
    try {
      comps = JSON.parse(comps);
    } catch (e) {
      comps = [];
    }
  }

  if (Array.isArray(comps)) {
    const bodyComp = comps.find((c) => (c.type || "").toUpperCase() === "BODY");
    if (bodyComp?.text) return bodyComp.text;
    if (bodyComp?.content) return bodyComp.content;
    if (bodyComp?.body) return bodyComp.body;
  } else if (comps && typeof comps === "object") {
    if (comps.text) return comps.text;
    if (comps.body) return comps.body;
  }

  return "";
};

const getTemplateHeaderText = (template) => {
  if (!template) return "";
  if (template.headerText) return template.headerText;
  if (template.header)
    return typeof template.header === "string"
      ? template.header
      : template.header?.text;

  let comps = template.components;
  if (typeof comps === "string") {
    try {
      comps = JSON.parse(comps);
    } catch (e) {
      comps = [];
    }
  }

  if (Array.isArray(comps)) {
    const headerComp = comps.find(
      (c) => (c.type || "").toUpperCase() === "HEADER",
    );
    if (headerComp?.text) return headerComp.text;
  }
  return "";
};

const getTemplateFooterText = (template) => {
  if (!template) return "";
  if (template.footerText) return template.footerText;
  if (template.footer)
    return typeof template.footer === "string"
      ? template.footer
      : template.footer?.text;

  let comps = template.components;
  if (typeof comps === "string") {
    try {
      comps = JSON.parse(comps);
    } catch (e) {
      comps = [];
    }
  }

  if (Array.isArray(comps)) {
    const footerComp = comps.find(
      (c) => (c.type || "").toUpperCase() === "FOOTER",
    );
    if (footerComp?.text) return footerComp.text;
  }
  return "";
};

const getTemplateButtons = (template) => {
  if (!template) return [];
  if (Array.isArray(template.buttons)) return template.buttons;

  let comps = template.components;
  if (typeof comps === "string") {
    try {
      comps = JSON.parse(comps);
    } catch (e) {
      comps = [];
    }
  }

  if (Array.isArray(comps)) {
    const buttonsComp = comps.find(
      (c) => (c.type || "").toUpperCase() === "BUTTONS",
    );
    if (Array.isArray(buttonsComp?.buttons)) return buttonsComp.buttons;
  }
  return [];
};

const renderTemplateTooltip = (template) => {
  const headerText = getTemplateHeaderText(template);
  const bodyText = getTemplateBodyText(template);
  const footerText = getTemplateFooterText(template);
  const buttons = getTemplateButtons(template);

  return (
    <div className="tw-p-2.5 tw-max-w-[300px] tw-text-left">
      <div className="tw-font-bold tw-text-xs tw-text-white tw-mb-1.5 tw-border-b tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-gray-600 tw-pb-1.5 tw-flex tw-items-center tw-justify-between tw-gap-2">
        <span>📄 {template.name}</span>
        <span className="tw-text-[10px] tw-font-normal tw-text-gray-300 tw-uppercase">
          ({template.language || "en"})
        </span>
      </div>
      {headerText && (
        <div className="tw-font-semibold tw-text-[11px] tw-text-gray-200 tw-mb-1">
          {headerText}
        </div>
      )}
      <div className="tw-text-xs tw-text-gray-100 tw-whitespace-pre-line tw-leading-relaxed">
        {bodyText || template.name}
      </div>
      {footerText && (
        <div className="tw-text-[10px] tw-text-gray-400 tw-mt-1.5">
          {footerText}
        </div>
      )}
      {buttons.length > 0 && (
        <div className="tw-mt-2 tw-pt-1.5 tw-border-t tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-gray-600 tw-flex tw-flex-wrap tw-gap-1">
          {buttons.map((b, idx) => (
            <span
              key={idx}
              className="tw-text-[10px] tw-bg-gray-700 tw-px-1.5 tw-py-0.5 tw-rounded tw-text-blue-300"
            >
              [{typeof b === "object" ? b.text : b}]
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

const parseMarkdown = (text) => {
  if (!text) return "";
  // Escape HTML tags to prevent XSS
  const escaped = text.replace(/</g, "&lt;").replace(/>/g, "&gt;");
  return escaped
    .replace(/\*(.*?)\*/g, "<strong>$1</strong>")
    .replace(/_(.*?)_/g, "<em>$1</em>")
    .replace(/~(.*?)~/g, "<del>$1</del>")
    .replace(/```([\s\S]*?)```/g, "<code>$1</code>");
};

const ChatWindow = ({
  activeChat,
  activeMessages,
  onSendMessage,
  templates = [],
  onSendTemplate,
  onCreateTemplate,
  loadMoreMessages,
  hasMoreMessages,
  onDeleteMessage,
  onClaim,
  onReleaseClaim,
  onOverrideClaim,
  currentUser,
  canOverride,
  error,
}) => {
  const alertContext = useAlert();
  const showAlert = alertContext?.showAlert;
  const { isWhatsAppCreate } = useContext(AuthContext);
  const lacksCreatePermission = isWhatsAppCreate === false;
  const hasOtherClaim =
    activeChat?.claimedByUserId &&
    activeChat?.claimedByUserId !== currentUser?.id;
  const isInputDisabled = hasOtherClaim || !!error || lacksCreatePermission;
  const isClaimHeldByMe =
    activeChat?.claimedByUserId &&
    activeChat?.claimedByUserId === currentUser?.id;
  const isClaimHeldByOther =
    activeChat?.claimedByUserId &&
    activeChat?.claimedByUserId !== currentUser?.id;
  const isUnclaimed = !activeChat?.claimedByUserId;

  const [inputValue, setInputValue] = useState("");
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
  const [isMediaPickerOpen, setIsMediaPickerOpen] = useState(false);
  const [stagedMediaList, setStagedMediaList] = useState([]);
  const chatFileInputRef = useRef(null);
  const [uploadingChatMedia, setUploadingChatMedia] = useState(false);

  useEffect(() => {
    setStagedMediaList([]);
  }, [activeChat?.id]);

  const messagesContainerRef = useRef(null);
  const inputRef = useRef(null);

  const handleEmojiSelect = (emoji) => {
    if (!inputRef.current) {
      setInputValue((prev) => prev + emoji);
      return;
    }
    const inputElement = inputRef.current.input || inputRef.current;
    if (inputElement && typeof inputElement.selectionStart === "number") {
      const start = inputElement.selectionStart;
      const end = inputElement.selectionEnd;
      const newValue =
        inputValue.substring(0, start) + emoji + inputValue.substring(end);
      setInputValue(newValue);
      setTimeout(() => {
        if (inputElement.setSelectionRange) {
          const newCursor = start + emoji.length;
          inputElement.setSelectionRange(newCursor, newCursor);
        }
        inputElement.focus();
      }, 0);
    } else {
      setInputValue((prev) => prev + emoji);
    }
  };

  const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  };

  const lastMessage = activeMessages[activeMessages.length - 1];
  const lastMessageKey = lastMessage
    ? `${lastMessage.id}_${lastMessage.sender}_${lastMessage.text}`
    : null;

  useEffect(() => {
    const timer = setTimeout(() => {
      scrollToBottom();
    }, 50);
    return () => clearTimeout(timer);
  }, [activeChat?.id, lastMessageKey]);

  const calculateRemainingTime = (expiresAt) => {
    if (!expiresAt) return null;
    const now = moment();
    const expiry = moment(expiresAt);
    const duration = moment.duration(expiry.diff(now));
    if (duration.asSeconds() <= 0) return "Expired";
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    return `${hours}h ${minutes}m`;
  };

  const [remainingTime, setRemainingTime] = useState(
    calculateRemainingTime(activeChat?.serviceWindowExpiresAt),
  );

  useEffect(() => {
    setRemainingTime(
      calculateRemainingTime(activeChat?.serviceWindowExpiresAt),
    );
    const timer = setInterval(() => {
      setRemainingTime(
        calculateRemainingTime(activeChat?.serviceWindowExpiresAt),
      );
    }, 60000); // Update every minute
    return () => clearInterval(timer);
  }, [activeChat?.serviceWindowExpiresAt]);

  let chatStatus = activeChat?.status || "Active";
  if (
    activeMessages.length > 0 &&
    !activeMessages.some((m) => m.sender === "user") &&
    chatStatus !== "New"
  ) {
    chatStatus = "Awaiting Reply";
  }

  if (
    remainingTime === "Expired" &&
    chatStatus !== "New" &&
    chatStatus !== "Awaiting Reply"
  ) {
    chatStatus = "Re-engage";
  }

  const isNew = chatStatus === "New" || activeMessages.length === 0;

  const [isTemplateModalVisible, setIsTemplateModalVisible] = useState(false);
  const [selectedTemplateName, setSelectedTemplateName] = useState(null);
  const [templateMappings, setTemplateMappings] = useState({
    header: {},
    body: {},
  });
  const [templateSendError, setTemplateSendError] = useState(null);
  const [selectedTemplateMediaObj, setSelectedTemplateMediaObj] =
    useState(null);
  const [isTemplateMediaPickerVisible, setIsTemplateMediaPickerVisible] =
    useState(false);

  const handleTemplateSelection = (val) => {
    setSelectedTemplateName(val);
    setTemplateSendError(null);
    const template = templates.find((t) => t.name === val);
    const initialMappings = { header: {}, body: {} };
    if (template && template.defaultMediaAssetId) {
      setSelectedTemplateMediaObj({
        id: template.defaultMediaAssetId,
        fileName: "Default Template Media",
      });
    } else {
      setSelectedTemplateMediaObj(null);
    }
    if (template && template.components) {
      let comps = [];
      try {
        comps =
          typeof template.components === "string"
            ? JSON.parse(template.components)
            : template.components;
      } catch (e) {}

      const extract = (text) => {
        if (!text) return [];
        const m = text.match(/\{\{(\d+)\}\}/g);
        return m ? [...new Set(m.map((x) => x.replace(/[{}]/g, "")))] : [];
      };

      const hasLead = !!activeChat?.clientLeadId;

      const headerVars = extract(comps.find((c) => c.type === "HEADER")?.text);
      headerVars.forEach((v) => {
        initialMappings.header[v] = {
          isDynamic: hasLead,
          attribute: hasLead ? "firstName" : "",
          value: "",
        };
      });

      const bodyVars = extract(comps.find((c) => c.type === "BODY")?.text);
      bodyVars.forEach((v) => {
        initialMappings.body[v] = {
          isDynamic: hasLead,
          attribute: hasLead ? "firstName" : "",
          value: "",
        };
      });
    }
    setTemplateMappings(initialMappings);
  };

  const handleScroll = (e) => {
    // Load more when scrolled near the top
    if (e.target.scrollTop < 50 && hasMoreMessages) {
      if (loadMoreMessages) loadMoreMessages();
    }
  };

  const handleSendTemplateClick = () => {
    if (selectedTemplateName) {
      const template = templates.find((t) => t.name === selectedTemplateName);
      if (template && onSendTemplate) {
        // Validate that all required mappings are filled
        let isValid = true;

        ["header", "body"].forEach((type) => {
          Object.values(templateMappings[type]).forEach((mapping) => {
            if (mapping.isDynamic && !mapping.attribute) isValid = false;
            if (!mapping.isDynamic && !mapping.value.trim()) isValid = false;
          });
        });

        if (!isValid) {
          if (showAlert) {
            showAlert("error", "Please fill in all template variables");
          } else {
            message.error("Please fill in all template variables");
          }
          return;
        }

        let mappingConfig = null;
        const comps =
          typeof template.components === "string"
            ? JSON.parse(template.components)
            : template.components;
        const headerComp = comps?.find((c) => c.type === "HEADER");
        const isMediaHeader =
          headerComp &&
          ["IMAGE", "VIDEO", "DOCUMENT"].includes(
            (headerComp.format || "").toUpperCase(),
          );

        if (isMediaHeader && !selectedTemplateMediaObj) {
          if (showAlert) {
            showAlert("error", "Please select a media file for this template");
          } else {
            message.error("Please select a media file for this template");
          }
          return;
        }

        if (
          Object.keys(templateMappings.header).length > 0 ||
          Object.keys(templateMappings.body).length > 0 ||
          isMediaHeader
        ) {
          mappingConfig = {
            type: "dynamic",
            header: isMediaHeader
              ? {
                  isDynamic: false,
                  value: selectedTemplateMediaObj.id.toString(),
                }
              : templateMappings.header,
            body: templateMappings.body,
          };
        }

        const promise = onSendTemplate(template, mappingConfig);
        if (promise && promise.then) {
          promise
            .then(() => {
              setIsTemplateModalVisible(false);
              setSelectedTemplateName(null);
              setTemplateMappings({ header: {}, body: {} });
              setSelectedTemplateMediaObj(null);
              setTemplateSendError(null);
            })
            .catch((e) => {
              setTemplateSendError(
                e.message || "An error occurred while sending the template.",
              );
            });
        } else {
          setIsTemplateModalVisible(false);
          setSelectedTemplateName(null);
          setTemplateMappings({ header: {}, body: {} });
          setTemplateSendError(null);
        }
      }
    } else {
      if (showAlert) {
        showAlert("error", "Please select a template");
      } else {
        message.error("Please select a template");
      }
    }
  };

  const handleSend = () => {
    if (["Awaiting Reply", "Re-engage", "New"].includes(chatStatus)) {
      if (showAlert) {
        showAlert("warning", "Custom messaging is disabled in this state.");
      } else {
        message.warning("Custom messaging is disabled in this state.");
      }
      return;
    }
    const mediaIds = stagedMediaList.map((m) => m.id).filter(Boolean);
    if ((inputValue.trim() || mediaIds.length > 0) && onSendMessage) {
      onSendMessage(inputValue.trim() || null, mediaIds);
      setInputValue("");
      setStagedMediaList([]);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleQuickReply = (text) => {
    if (["Awaiting Reply", "Re-engage", "New"].includes(chatStatus)) return;
    if (onSendMessage) {
      onSendMessage(text);
    }
  };

  const openTemplateManager = (actionName) => {
    setIsTemplateModalVisible(true);
  };

  const handleTemplateChipClick = (template) => {
    const compsString =
      typeof template.components === "string"
        ? template.components
        : JSON.stringify(template.components || []);
    const hasVars = compsString.match(/\{\{(\d+)\}\}/);

    let hasMedia = false;
    try {
      const comps =
        typeof template.components === "string"
          ? JSON.parse(template.components)
          : template.components || [];
      const headerComp = comps.find((c) => c.type === "HEADER");
      if (
        headerComp &&
        ["IMAGE", "VIDEO", "DOCUMENT"].includes(
          (headerComp.format || "").toUpperCase(),
        )
      ) {
        hasMedia = true;
      }
    } catch (e) {}

    if (hasVars || hasMedia) {
      handleTemplateSelection(template.name);
      setIsTemplateModalVisible(true);
    } else {
      if (onSendTemplate) {
        const promise = onSendTemplate(template);
        if (promise && promise.catch) {
          promise.catch((e) => {
            const msg =
              "Failed to send template: " + (e.message || "Unknown error");
            if (showAlert) {
              showAlert("error", msg);
            } else {
              message.error(msg);
            }
          });
        }
      }
    }
  };

  const handleMediaSelected = (media) => {
    setIsMediaPickerOpen(false);
    if (
      media &&
      (media.id || media.url || media.fileUrl || media.originalFilename)
    ) {
      const name =
        media.originalFilename ||
        media.filename ||
        media.name ||
        "Attached Media";
      let type = (media.mediaType || media.fileType || "").toUpperCase();
      if (!type) {
        if (/\.(jpg|jpeg|png|webp|gif|bmp|svg)$/i.test(name)) type = "IMAGE";
        else if (/\.(mp4|3gp|mov|avi|mkv|webm)$/i.test(name)) type = "VIDEO";
        else type = "DOCUMENT";
      }

      const newItem = {
        id: media.id || media.mediaAssetId,
        name: name,
        previewUrl: media.mediaUrl || media.fileUrl || media.url,
        type: type,
        size: media.fileSize || media.size,
      };
      setStagedMediaList((prev) => [...prev, newItem]);
    }
  };

  const handleChatFileSelect = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    e.target.value = "";

    setUploadingChatMedia(true);
    try {
      const uploadPromises = files.map(async (file) => {
        const formData = new FormData();
        formData.append("file", file);

        const res = await postAuthMethod("/api/media", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const localPreviewUrl =
          file.type.startsWith("image/") || file.type.startsWith("video/")
            ? URL.createObjectURL(file)
            : null;

        let fileType = "DOCUMENT";
        if (file.type.startsWith("image/")) fileType = "IMAGE";
        else if (file.type.startsWith("video/")) fileType = "VIDEO";

        return {
          id:
            res.data?.id ||
            res.data?.mediaAssetId ||
            (typeof res.data === "string" ? res.data : null),
          name:
            file.name ||
            res.data?.originalFilename ||
            res.data?.filename ||
            "Attached Media",
          previewUrl:
            localPreviewUrl ||
            res.data?.mediaUrl ||
            res.data?.fileUrl ||
            res.data?.url,
          type: fileType,
          size: file.size || res.data?.fileSize || res.data?.size,
        };
      });

      const newMediaItems = await Promise.all(uploadPromises);
      const validItems = newMediaItems.filter((item) => item.id);

      setStagedMediaList((prev) => [...prev, ...validItems]);

      if (showAlert) {
        showAlert(
          "success",
          `${validItems.length > 1 ? `${validItems.length} files` : "File"} attached successfully`,
        );
      } else {
        message.success(
          `${validItems.length > 1 ? `${validItems.length} files` : "File"} attached successfully`,
        );
      }
    } catch (error) {
      const errMsg = error.response?.data?.message || "File upload failed";
      if (showAlert) {
        showAlert("error", errMsg);
      } else {
        message.error(errMsg);
      }
    } finally {
      setUploadingChatMedia(false);
    }
  };

  const handleRemoveStagedMedia = (indexToRemove) => {
    setStagedMediaList((prev) => {
      const item = prev[indexToRemove];
      if (item && item.previewUrl && item.previewUrl.startsWith("blob:")) {
        URL.revokeObjectURL(item.previewUrl);
      }
      return prev.filter((_, idx) => idx !== indexToRemove);
    });
  };

  const renderStagedMediaPreview = () => {
    if (!stagedMediaList || stagedMediaList.length === 0) return null;

    return (
      <div className="tw-mb-2.5 tw-p-3 tw-bg-[#F8FAFC] tw-border tw-border-solid tw-border-emerald-200/80 tw-rounded-2xl tw-shadow-[0_2px_10px_rgba(0,0,0,0.04)] tw-flex tw-flex-col tw-gap-2">
        <div className="tw-flex tw-items-center tw-justify-between tw-px-0.5">
          <span className="tw-text-xs tw-font-bold tw-text-slate-700 tw-flex tw-items-center tw-gap-1.5">
            <span className="tw-w-2 tw-h-2 tw-rounded-full tw-bg-emerald-500"></span>
            Attached Media ({stagedMediaList.length})
          </span>
          {stagedMediaList.length > 1 && (
            <button
              type="button"
              onClick={() => setStagedMediaList([])}
              className="tw-text-[11px] tw-font-semibold tw-text-red-500 hover:tw-text-red-600 tw-bg-transparent tw-border-none tw-cursor-pointer"
            >
              Clear All
            </button>
          )}
        </div>

        <div className="tw-flex tw-items-center tw-gap-3 tw-overflow-x-auto sleek-scrollbar tw-py-1 tw-px-0.5">
          {stagedMediaList.map((item, idx) => {
            const formattedSize = item.size
              ? item.size > 1024 * 1024
                ? `${(item.size / (1024 * 1024)).toFixed(1)} MB`
                : `${Math.round(item.size / 1024)} KB`
              : "";

            return (
              <div key={idx} className="tw-relative tw-group tw-flex-shrink-0">
                {item.type === "IMAGE" && item.previewUrl ? (
                  <div className="tw-w-20 tw-h-20 tw-rounded-xl tw-overflow-hidden tw-border tw-border-solid tw-border-gray-200 tw-bg-white tw-shadow-sm tw-relative">
                    <img
                      src={item.previewUrl}
                      alt={item.name}
                      className="tw-w-full tw-h-full tw-object-cover"
                    />
                    <div className="tw-absolute tw-inset-0 tw-bg-black/40 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-flex tw-items-end tw-p-1">
                      <span className="tw-text-[9px] tw-text-white tw-font-medium tw-truncate tw-w-full">
                        {item.name}
                      </span>
                    </div>
                  </div>
                ) : item.type === "VIDEO" ? (
                  <div className="tw-w-20 tw-h-20 tw-rounded-xl tw-bg-slate-900 tw-text-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-border tw-border-solid tw-border-slate-700 tw-shadow-sm tw-relative tw-p-1">
                    {item.previewUrl ? (
                      <video
                        src={item.previewUrl}
                        className="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover tw-opacity-40 tw-rounded-xl"
                      />
                    ) : null}
                    <VideoCameraOutlined className="tw-text-xl tw-text-emerald-400 tw-z-10" />
                    <span className="tw-text-[9px] tw-text-gray-200 tw-truncate tw-w-full tw-text-center tw-z-10 tw-mt-1">
                      {item.name}
                    </span>
                  </div>
                ) : (
                  <div className="tw-h-20 tw-min-w-[130px] tw-max-w-[170px] tw-px-3 tw-py-2 tw-rounded-xl tw-bg-white tw-border tw-border-solid tw-border-emerald-100 tw-shadow-sm tw-flex tw-items-center tw-gap-2.5">
                    <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-bg-emerald-50 tw-text-[#25D366] tw-flex tw-items-center tw-justify-center tw-shrink-0">
                      <FileOutlined className="tw-text-xl" />
                    </div>
                    <div className="tw-flex tw-flex-col tw-min-w-0 tw-flex-1">
                      <span
                        className="tw-text-xs tw-font-semibold tw-text-gray-800 tw-truncate"
                        title={item.name}
                      >
                        {item.name}
                      </span>
                      <span className="tw-text-[10px] tw-text-gray-400">
                        {formattedSize || "Document"}
                      </span>
                    </div>
                  </div>
                )}

                <button
                  type="button"
                  onClick={() => handleRemoveStagedMedia(idx)}
                  className="tw-absolute -tw-top-1 -tw-right-1 tw-w-4 tw-h-4 tw-rounded-full tw-bg-red-500 hover:tw-bg-red-600 tw-text-white tw-flex tw-items-center tw-justify-center tw-text-[9px] tw-font-bold tw-border-none tw-cursor-pointer tw-shadow-sm tw-z-20 tw-transition-transform hover:tw-scale-110"
                  title="Remove"
                >
                  ✕
                </button>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="tw-flex-1 tw-flex tw-flex-col tw-bg-white tw-min-w-0 tw-min-h-0">
      {/* Unified Conversation Status Bar */}
      {(() => {
        const isWindowOpen =
          chatStatus === "Active" ||
          !["Awaiting Reply", "Re-engage", "New"].includes(chatStatus);
        const isAwaiting = chatStatus === "Awaiting Reply";
        const isExpired = chatStatus === "Re-engage";

        const hasStatus =
          isWindowOpen ||
          isAwaiting ||
          isExpired ||
          isUnclaimed ||
          isClaimHeldByMe ||
          isClaimHeldByOther;
        if (!hasStatus) return null;

        let bgStyle = "tw-bg-[#F4FAF6] tw-border-emerald-200/70";
        if (isAwaiting) {
          bgStyle = "tw-bg-[#FFFDF5] tw-border-amber-200/80";
        } else if (isExpired) {
          bgStyle = "tw-bg-[#FEF8F8] tw-border-rose-200/70";
        } else if (isClaimHeldByOther) {
          bgStyle = "tw-bg-[#FDF6F6] tw-border-rose-200/70";
        }

        return (
          <div
            className={`tw-border-b tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-solid ${bgStyle} tw-px-3.5 md:tw-px-4 tw-py-1.5 tw-flex tw-items-center tw-justify-between tw-gap-3 tw-shrink-0 tw-z-10 tw-transition-colors`}
          >
            {/* Left: Window Session Status */}
            <div className="tw-flex tw-items-center tw-gap-2.5 tw-min-w-0 tw-flex-wrap sm:tw-flex-nowrap">
              {isWindowOpen && (
                <div className="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
                  <span className="tw-relative tw-flex tw-h-2 tw-w-2 tw-shrink-0">
                    <span className="tw-animate-ping tw-absolute tw-inline-flex tw-h-full tw-w-full tw-rounded-full tw-bg-emerald-400 tw-opacity-75"></span>
                    <span className="tw-relative tw-inline-flex tw-rounded-full tw-h-2 tw-w-2 tw-bg-[#25D366]"></span>
                  </span>
                  <span className="tw-text-xs tw-font-semibold tw-text-emerald-900 tw-whitespace-nowrap">
                    24-hour window open
                  </span>
                  <Tooltip title="Meta 24-hour customer response window">
                    <span className="tw-inline-flex tw-items-center tw-gap-1 tw-text-[11px] tw-font-semibold tw-text-emerald-700 tw-bg-emerald-100/70 tw-border tw-border-solid tw-border-emerald-200 tw-px-2 tw-py-0.5 tw-rounded-md tw-whitespace-nowrap">
                      <ClockCircleOutlined className="tw-text-[10px]" />
                      <span>{remainingTime || "24h 0m"}</span>
                    </span>
                  </Tooltip>
                </div>
              )}

              {isAwaiting && (
                <div className="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
                  <span className="tw-w-2 tw-h-2 tw-rounded-full tw-bg-amber-400 tw-shrink-0"></span>
                  <span className="tw-text-xs tw-font-semibold tw-text-amber-800 tw-whitespace-nowrap">
                    Waiting for customer reply
                  </span>
                  <span className="tw-text-[11px] tw-text-amber-700/80 tw-hidden md:tw-inline">
                    — Templates only
                  </span>
                </div>
              )}

              {isExpired && (
                <div className="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
                  <span className="tw-w-2 tw-h-2 tw-rounded-full tw-bg-rose-500 tw-shrink-0"></span>
                  <span className="tw-text-xs tw-font-semibold tw-text-rose-800 tw-whitespace-nowrap">
                    24-hour session expired
                  </span>
                  <span className="tw-text-[11px] tw-text-rose-700/80 tw-hidden md:tw-inline">
                    — Only approved templates can be sent
                  </span>
                </div>
              )}
            </div>

            {/* Right: Claim Management & Template Quick Action */}
            <div className="tw-flex tw-items-center tw-gap-2 tw-shrink-0">
              {onCreateTemplate && (
                <button
                  type="button"
                  onClick={onCreateTemplate}
                  className="tw-text-[11px] tw-font-semibold tw-text-emerald-800 hover:tw-text-emerald-950 tw-bg-white hover:tw-bg-emerald-50 tw-border tw-border-solid tw-border-emerald-200 tw-px-2.5 tw-py-0.5 tw-rounded-md tw-cursor-pointer tw-transition-all tw-flex tw-items-center tw-gap-1"
                >
                  <PlusOutlined className="tw-text-[9px]" />
                  <span>Template</span>
                </button>
              )}

              {isClaimHeldByMe && (
                <div className="tw-flex tw-items-center tw-gap-1.5">
                  <span className="tw-inline-flex tw-items-center tw-gap-1 tw-text-[11px] tw-font-medium tw-text-emerald-800 tw-bg-white/90 tw-border tw-border-solid tw-border-emerald-200 tw-px-2 tw-py-0.5 tw-rounded-md">
                    <CheckCircleFilled className="tw-text-[11px] tw-text-emerald-500" />
                    <span>Claimed by you</span>
                  </span>
                  <button
                    type="button"
                    onClick={onReleaseClaim}
                    className="tw-text-[11px] tw-font-semibold tw-text-slate-600 hover:tw-text-rose-600 tw-bg-white hover:tw-bg-rose-50 tw-border tw-border-solid tw-border-slate-200 hover:tw-border-rose-200 tw-px-2 tw-py-0.5 tw-rounded-md tw-cursor-pointer tw-transition-all"
                  >
                    Release
                  </button>
                </div>
              )}

              {isUnclaimed && (
                <div className="tw-flex tw-items-center tw-gap-2">
                  <span className="tw-text-[11px] tw-font-medium tw-text-slate-500 tw-hidden sm:tw-inline">
                    Unassigned
                  </span>
                  {lacksCreatePermission ? (
                    <Tooltip title="You do not have permission to claim or reply">
                      <Button
                        size="small"
                        type="primary"
                        disabled
                        className="!tw-text-[11px] !tw-h-6"
                      >
                        Claim
                      </Button>
                    </Tooltip>
                  ) : (
                    <Button
                      size="small"
                      type="primary"
                      onClick={onClaim}
                      className="!tw-text-[11px] !tw-h-6 !tw-bg-[#25D366] hover:!tw-bg-[#20b857] !tw-border-none !tw-font-medium tw-shadow-none"
                    >
                      Claim Conversation
                    </Button>
                  )}
                </div>
              )}

              {isClaimHeldByOther && (
                <div className="tw-flex tw-items-center tw-gap-1.5">
                  <span className="tw-inline-flex tw-items-center tw-gap-1 tw-text-[11px] tw-font-medium tw-text-rose-700 tw-bg-white/90 tw-border tw-border-solid tw-border-rose-200 tw-px-2 tw-py-0.5 tw-rounded-md">
                    <LockOutlined className="tw-text-[10px]" />
                    <span>Claimed by other</span>
                  </span>
                  {canOverride && (
                    <Button
                      size="small"
                      danger
                      onClick={onOverrideClaim}
                      className="!tw-text-[11px] !tw-h-5 !tw-px-2"
                    >
                      Override
                    </Button>
                  )}
                </div>
              )}
            </div>
          </div>
        );
      })()}

      {/* Chat Messages Area */}
      <div
        ref={messagesContainerRef}
        className="tw-flex-1 tw-overflow-y-auto whatsapp-chat-bg tw-px-3 md:tw-px-4 tw-py-3 md:tw-py-4 tw-flex tw-flex-col tw-gap-2 tw-min-h-0"
        onScroll={handleScroll}
      >
        {error ? (
          <div className="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-text-center tw-py-8">
            <Result status="403" title="Access Denied" subTitle={error} />
          </div>
        ) : isNew ? (
          <div className="tw-flex-1 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-py-8">
            <div className="tw-w-16 tw-h-16 tw-bg-[#E0E7FF] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mb-4">
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#5D44FF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
              </svg>
            </div>
            <h2 className="tw-text-[18px] tw-font-bold tw-text-text-primary tw-mb-1 tw-m-0">
              Start the conversation
            </h2>
            <p className="tw-text-[12px] tw-text-sub-text tw-max-w-[400px] tw-mb-6 tw-leading-[1.5] tw-m-0">
              WhatsApp policy requires the first message to be an approved
              template. Pick one to open the 24-hour conversation window with
              this guest.
            </p>
            <button
              type="button"
              onClick={() =>
                openTemplateManager("Choose Pre-approved Template")
              }
              className="tw-bg-[#5D44FF] hover:tw-bg-[#4B34E6] tw-text-white tw-font-semibold tw-text-xs tw-px-5 tw-py-2.5 tw-rounded-lg tw-border-none tw-cursor-pointer tw-shadow-sm tw-transition-colors tw-mb-4"
            >
              Choose Pre-approved Template
            </button>
            <div className="tw-flex tw-items-center tw-w-full tw-max-w-[280px] tw-mb-4">
              <div className="tw-flex-1 tw-h-[1px] tw-bg-gray-200"></div>
              <span className="tw-px-3 tw-text-[10px] tw-text-gray-400 tw-font-semibold tw-uppercase">
                Or
              </span>
              <div className="tw-flex-1 tw-h-[1px] tw-bg-gray-200"></div>
            </div>
            <button
              type="button"
              onClick={() => openTemplateManager("Create New Template")}
              className="tw-text-[#5D44FF] hover:tw-text-[#4B34E6] tw-font-semibold tw-text-xs tw-bg-transparent tw-border-none tw-cursor-pointer tw-flex tw-items-center tw-gap-1"
            >
              <span className="tw-text-sm">+</span> Create New Template
            </button>
          </div>
        ) : (
          <>
            {(() => {
              let lastDateLabel = "";
              return activeMessages.map((msg, index) => {
                const currentDateLabel = getChatWindowDateLabel(msg.timestamp);
                const showSeparator =
                  currentDateLabel && currentDateLabel !== lastDateLabel;
                if (showSeparator) {
                  lastDateLabel = currentDateLabel;
                }
                return (
                  <React.Fragment key={msg.id || index}>
                    {showSeparator && (
                      <div className="tw-flex tw-justify-center tw-my-4 tw-w-full">
                        <span className="tw-bg-[#F0F2F5] tw-text-[#54656F] tw-text-[11px] tw-font-medium tw-px-3 tw-py-1 tw-rounded-lg tw-shadow-sm tw-uppercase">
                          {currentDateLabel}
                        </span>
                      </div>
                    )}
                    <div
                      className={`tw-flex tw-items-start tw-gap-3 ${
                        msg.sender === "bot"
                          ? "tw-self-end tw-flex-row-reverse"
                          : "tw-self-start"
                      }`}
                    >
                      {msg.sender === "user" ? (
                        <div className="tw-w-8 tw-h-8 tw-rounded-full tw-border-2 tw-border-[#1d9bf0] tw-p-[2px] tw-bg-white tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-mt-0.5">
                          <UserInitialsAvatar
                            name={activeChat.name}
                            phone={activeChat.phone}
                            src={activeChat.avatar}
                            size={24}
                            className="tw-flex-shrink-0"
                          />
                        </div>
                      ) : (
                        <Avatar
                          src={botMascot}
                          size={32}
                          className="tw-flex-shrink-0 tw-border tw-border-solid tw-border-[#c6f0d0] tw-p-0.5 tw-bg-white tw-mt-0.5"
                        />
                      )}

                      <div
                        className={`tw-flex tw-flex-col ${
                          msg.sender === "bot"
                            ? "tw-items-end"
                            : "tw-items-start"
                        }`}
                      >
                        <div className="tw-flex tw-items-center tw-gap-2">
                          <div
                            className={`tw-relative tw-group tw-px-4 tw-py-3 tw-rounded-[12px] tw-text-sm tw-leading-[1.55] tw-whitespace-pre-line  ${
                              msg.sender === "bot"
                                ? "tw-bg-[#DDFFE9] tw-text-text-primary tw-border tw-border-solid tw-border-[#c6f0d0] tw-max-w-[min(100%,480px)] tw-rounded-tl-[10px] tw-rounded-tr-[1px] tw-rounded-br-[10px] tw-rounded-bl-[10px] tw-shadow-[0px_1px_3.2px_0px_#00000040]"
                                : "tw-bg-[#F0F6F6] tw-text-text-primary tw-border tw-border-solid tw-border-[#dde8ed] tw-max-w-[min(100%,445px)] tw-shadow-[0px_1px_3.2px_0px_#00000040] tw-rounded-tl-[1px] tw-rounded-tr-[10px] tw-rounded-br-[10px] tw-rounded-bl-[10px]"
                            }`}
                          >
                            {(() => {
                              const renderMedia = () => {
                                if (!msg.mediaType && !msg.mediaStatus)
                                  return null;

                                const hasCaption = Boolean(
                                  msg.text &&
                                    !msg.text.match(
                                      /^\[(Document|Image|Video|Audio|Sticker) Message\]$/i,
                                    ),
                                );

                                if (
                                  msg.mediaStatus === "PENDING" ||
                                  msg.mediaStatus === "PROCESSING"
                                ) {
                                  return (
                                    <div
                                      className={`tw-bg-gray-100 tw-p-3 tw-rounded-lg tw-border tw-border-gray-200 ${hasCaption ? "tw-mb-2" : ""}`}
                                    >
                                      <div className="tw-flex tw-items-center tw-gap-2 tw-text-gray-500">
                                        <div className="tw-animate-spin tw-w-4 tw-h-4 tw-border-2 tw-border-[#00a884] tw-border-t-transparent tw-rounded-full"></div>
                                        <span className="tw-text-xs tw-italic">
                                          Downloading media...
                                        </span>
                                      </div>
                                    </div>
                                  );
                                }
                                if (msg.mediaStatus === "STORAGE_BLOCKED") {
                                  return (
                                    <div
                                      className={`tw-bg-gray-100 tw-p-3 tw-rounded-lg tw-border tw-border-gray-200 ${hasCaption ? "tw-mb-2" : ""}`}
                                    >
                                      <div className="tw-flex tw-items-center tw-gap-2 tw-text-gray-500">
                                        <FileExclamationOutlined className="tw-text-lg tw-text-red-400" />
                                        <span className="tw-text-xs tw-italic">
                                          Media was never successfully stored.
                                          Please ask the sender to send it
                                          again.
                                        </span>
                                      </div>
                                    </div>
                                  );
                                }
                                if (msg.mediaStatus === "MEDIA_DELETED") {
                                  return (
                                    <div
                                      className={`tw-bg-gray-100 tw-p-3 tw-rounded-lg tw-border tw-border-gray-200 ${hasCaption ? "tw-mb-2" : ""}`}
                                    >
                                      <div className="tw-flex tw-items-center tw-gap-2 tw-text-gray-500">
                                        <DeleteOutlined className="tw-text-lg" />
                                        <span className="tw-text-xs tw-italic">
                                          This media is no longer available
                                          because it was removed to free storage
                                          space. Ask the sender to send it
                                          again.
                                        </span>
                                      </div>
                                    </div>
                                  );
                                }
                                if (msg.mediaStatus === "DOWNLOAD_FAILED") {
                                  return (
                                    <div
                                      className={`tw-bg-gray-100 tw-p-3 tw-rounded-lg tw-border tw-border-gray-200 ${hasCaption ? "tw-mb-2" : ""}`}
                                    >
                                      <div className="tw-flex tw-items-center tw-gap-2 tw-text-red-500">
                                        <WarningOutlined className="tw-text-lg" />
                                        <span className="tw-text-xs">
                                          Failed to download media from Meta.
                                        </span>
                                      </div>
                                    </div>
                                  );
                                }

                                if (msg.mediaType === "IMAGE" && msg.mediaUrl) {
                                  return (
                                    <div
                                      className={hasCaption ? "tw-mb-2" : ""}
                                    >
                                      <img
                                        src={msg.mediaUrl}
                                        alt="Image"
                                        className="tw-max-w-full tw-rounded-lg tw-max-h-64 tw-object-contain tw-bg-black/5"
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src =
                                            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxyZWN0IHg9IjMiIHk9IjMiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgcng9IjIiIHJ5PSIyIj48L3JlY3Q+PGNpcmNsZSBjeD0iOC41IiBjeT0iOC41IiByPSIxLjUiPjwvY2lyY2xlPjxwb2x5bGluZSBwb2ludHM9IjIxIDE1IDE2IDEwIDUgMjEiPjwvcG9seWxpbmU+PC9zdmc+";
                                        }}
                                      />
                                    </div>
                                  );
                                }

                                if (
                                  ["VIDEO", "DOCUMENT", "AUDIO"].includes(
                                    msg.mediaType,
                                  ) &&
                                  msg.mediaUrl
                                ) {
                                  return (
                                    <div
                                      className={`tw-bg-black/5 tw-p-3 tw-rounded-lg tw-flex tw-items-center tw-justify-between tw-border tw-border-black/10 ${hasCaption ? "tw-mb-2" : ""}`}
                                    >
                                      <div className="tw-flex tw-items-center tw-gap-3 tw-overflow-hidden">
                                        <div className="tw-w-10 tw-h-10 tw-bg-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-[#00a884] tw-shrink-0">
                                          {msg.mediaType === "VIDEO" ? (
                                            <VideoCameraOutlined />
                                          ) : msg.mediaType === "AUDIO" ? (
                                            <AudioOutlined />
                                          ) : (
                                            <FileOutlined />
                                          )}
                                        </div>
                                        <div className="tw-flex tw-flex-col tw-overflow-hidden">
                                          <span className="tw-text-sm tw-font-medium tw-truncate">
                                            {msg.mediaFileName || "File"}
                                          </span>
                                          <span className="tw-text-xs tw-text-gray-500 tw-uppercase">
                                            {msg.mediaType}
                                          </span>
                                        </div>
                                      </div>
                                      <a
                                        href={msg.mediaUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="tw-text-[#00a884] hover:tw-text-[#008f6f] tw-ml-4 tw-shrink-0"
                                      >
                                        <DownloadOutlined className="tw-text-lg" />
                                      </a>
                                    </div>
                                  );
                                }

                                return null;
                              };

                              try {
                                if (
                                  msg.text &&
                                  msg.text.trim().startsWith("{")
                                ) {
                                  const templateData = JSON.parse(msg.text);
                                  if (templateData && templateData.isTemplate) {
                                    return (
                                      <div className="tw-flex tw-flex-col tw-gap-1.5">
                                        {renderMedia()}
                                        {templateData.header && (
                                          <div className="tw-font-bold tw-text-[13.5px] tw-text-gray-900 tw-leading-snug">
                                            {templateData.header}
                                          </div>
                                        )}
                                        {templateData.body && (
                                          <div
                                            className="tw-text-[13.5px] tw-text-gray-800 tw-leading-relaxed tw-whitespace-pre-wrap"
                                            dangerouslySetInnerHTML={{
                                              __html: parseMarkdown(
                                                templateData.body || "",
                                              ),
                                            }}
                                          />
                                        )}
                                        {templateData.footer && (
                                          <div className="tw-text-[11.5px] tw-text-gray-500 tw-leading-none tw-mt-0.5">
                                            {templateData.footer}
                                          </div>
                                        )}
                                        {templateData.buttons &&
                                          templateData.buttons.length > 0 && (
                                            <div
                                              className="tw-flex tw-flex-col tw-mt-1.5 tw-border-t tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-gray-200/60 tw-pt-1"
                                              style={{
                                                borderBottom: 0,
                                                borderLeft: 0,
                                                borderRight: 0,
                                              }}
                                            >
                                              {templateData.buttons.map(
                                                (btn, idx) => (
                                                  <div
                                                    key={idx}
                                                    className={`tw-text-center tw-text-[#00a884] hover:tw-text-[#008f6f] tw-font-semibold tw-text-[13px] tw-py-1.5 tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-cursor-pointer ${
                                                      idx > 0
                                                        ? "tw-border-t tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-gray-200/60"
                                                        : ""
                                                    }`}
                                                    style={{
                                                      borderBottom: 0,
                                                      borderLeft: 0,
                                                      borderRight: 0,
                                                      ...(idx > 0
                                                        ? {
                                                            borderTop:
                                                              "1px solid rgba(229, 231, 235, 0.6)",
                                                          }
                                                        : {}),
                                                    }}
                                                  >
                                                    {btn.type === "URL" ? (
                                                      <LinkOutlined />
                                                    ) : (
                                                      <span className="tw-rotate-180 tw-inline-block">
                                                        ↶
                                                      </span>
                                                    )}
                                                    {btn.text}
                                                  </div>
                                                ),
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    );
                                  }
                                }
                              } catch (e) {
                                // Fallback to normal text rendering
                              }

                              return (
                                <div className="tw-flex tw-flex-col">
                                  {renderMedia()}
                                  {msg.text &&
                                    !msg.text.match(
                                      /^\[(Document|Image|Video|Audio|Sticker) Message\]$/i,
                                    ) && (
                                      <div
                                        className="tw-whitespace-pre-wrap tw-break-words tw-leading-relaxed"
                                        dangerouslySetInnerHTML={{
                                          __html: parseMarkdown(msg.text || ""),
                                        }}
                                      />
                                    )}
                                </div>
                              );
                            })()}

                            <div className="tw-absolute tw-top-1.5 tw-right-2 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200">
                              <Dropdown
                                overlay={
                                  <Menu
                                    items={[
                                      {
                                        key: "1",
                                        label: "Delete Message",
                                        icon: <DeleteOutlined />,
                                        danger: true,
                                        onClick: () =>
                                          onDeleteMessage &&
                                          onDeleteMessage(msg.id),
                                      },
                                    ]}
                                  />
                                }
                                trigger={["click"]}
                                placement="bottomRight"
                              >
                                <Button
                                  type="text"
                                  icon={
                                    <DownOutlined className="tw-text-gray-400 hover:tw-text-gray-600 tw-text-[11px]" />
                                  }
                                  className="!tw-p-1 !tw-h-auto tw-min-w-0 tw-bg-transparent hover:tw-bg-black/5 tw-rounded-full"
                                />
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                        <div
                          className={`tw-flex tw-items-center tw-gap-1 tw-mt-1.5 tw-px-1 ${
                            msg.sender === "bot"
                              ? "tw-self-end"
                              : "tw-self-start"
                          }`}
                        >
                          <span className="tw-text-[10px] tw-leading-none tw-text-sub-text">
                            {msg.time}
                          </span>
                          {msg.sender === "bot" && (
                            <span className="tw-text-[10px]">
                              {msg.status === "PENDING_SUBMISSION" && (
                                <span className="tw-text-gray-400">🕒</span>
                              )}
                              {(msg.status === "ACCEPTED" ||
                                msg.status === "SENT") && (
                                <span className="tw-text-gray-400">✓</span>
                              )}
                              {msg.status === "DELIVERED" && (
                                <span className="tw-text-gray-400">✓✓</span>
                              )}
                              {msg.status === "READ" && (
                                <span className="tw-text-blue-500">✓✓</span>
                              )}
                              {msg.status === "FAILED" && (
                                <span className="tw-text-red-500">❌</span>
                              )}
                              {msg.status === "STALE" && (
                                <span className="tw-text-orange-500">⚠️</span>
                              )}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                );
              });
            })()}

            {activeChat?.isTyping && (
              <div className="tw-flex tw-items-end tw-gap-3 tw-self-start">
                <div className="tw-w-8 tw-h-8 tw-rounded-full tw-border-2 tw-border-[#1d9bf0] tw-p-[2px] tw-bg-white tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 tw-mb-5">
                  <UserInitialsAvatar
                    name={activeChat.name}
                    phone={activeChat.phone}
                    src={activeChat.avatar}
                    size={24}
                    className="tw-flex-shrink-0"
                  />
                </div>
                <div className="tw-flex tw-flex-col tw-items-start">
                  <div className="tw-px-4 tw-text-sm tw-py-3 tw-bg-[#F0F6F6] tw-text-sub-text tw-border tw-border-solid tw-border-[#dde8ed] tw-max-w-[min(100%,445px)] sm:tw-min-w-[260px] tw-shadow-[0px_1px_3.2px_0px_#00000040] tw-rounded-tl-[1px] tw-rounded-tr-[10px] tw-rounded-br-[10px] tw-rounded-bl-[10px]">
                    Guest is typing...
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Composer Section */}
      <div className="tw-px-3 md:tw-px-4 tw-py-3 tw-bg-white tw-border-t tw-border-b-0 tw-border-r-0 tw-border-l-0 tw-border-solid tw-border-border-secondary tw-shrink-0">
        {lacksCreatePermission ? (
          <div className="tw-bg-gray-50 tw-p-3 tw-text-center tw-text-gray-500 tw-text-sm tw-font-medium tw-border-t tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-gray-200">
            <Tooltip title="Contact your administrator for access">
              You do not have permission to reply.
            </Tooltip>
          </div>
        ) : (
          <>
            {(chatStatus === "Active" ||
              !["Awaiting Reply", "Re-engage", "New"].includes(chatStatus)) && (
              <>
                <div className="tw-flex tw-gap-2 tw-mb-3 tw-overflow-x-auto sleek-scrollbar tw-pb-1.5">
                  <div
                    onClick={() =>
                      handleQuickReply(
                        "Just following up on your booking payment",
                      )
                    }
                    className="tw-px-4 tw-py-1.5 tw-bg-[#DDFFE9] tw-text-text-primary tw-text-xs tw-font-medium tw-rounded-full tw-cursor-pointer tw-whitespace-nowrap hover:tw-bg-[#c9f2d1]"
                  >
                    Just following up on your booking payment
                  </div>
                  <div
                    onClick={() =>
                      handleQuickReply(
                        "Let me know if you need help completing payment",
                      )
                    }
                    className="tw-px-4 tw-py-1.5 tw-bg-[#DDFFE9] tw-text-text-primary tw-text-xs tw-font-medium tw-rounded-full tw-cursor-pointer tw-whitespace-nowrap hover:tw-bg-[#c9f2d1]"
                  >
                    Let me know if you need help completing payment
                  </div>
                  {templates
                    ?.filter((t) => t.status === "APPROVED")
                    ?.map((template) => (
                      <Tooltip
                        key={template.name}
                        title={renderTemplateTooltip(template)}
                        mouseEnterDelay={0.15}
                      >
                        <div
                          onClick={() => handleTemplateChipClick(template)}
                          className="tw-px-4 tw-py-1.5 tw-bg-[#F0EEFF] tw-text-[#5D44FF] tw-text-xs tw-font-medium tw-rounded-full tw-cursor-pointer tw-whitespace-nowrap hover:tw-bg-[#E5E1FF] tw-border tw-border-solid tw-border-[#DCD7FF]"
                        >
                          📄 {template.name}
                        </div>
                      </Tooltip>
                    ))}
                </div>

                {renderStagedMediaPreview()}

                <div className="tw-flex tw-items-center tw-gap-2 tw-bg-white tw-border tw-border-solid tw-border-[#25D366] tw-rounded-full tw-px-3.5 tw-py-2 tw-shadow-[0_1px_2px_rgba(0,0,0,0.05)]">
                  <Popover
                    content={
                      <EmojiPickerContent onSelectEmoji={handleEmojiSelect} />
                    }
                    trigger="click"
                    open={isEmojiPickerOpen}
                    onOpenChange={setIsEmojiPickerOpen}
                    placement="topLeft"
                  >
                    <Tooltip title="Emoji Picker">
                      <Button
                        type="text"
                        icon={
                          <SmileOutlined className="tw-text-[#6b7280] tw-text-[18px]" />
                        }
                        className="tw-flex-shrink-0 hover:tw-bg-transparent !tw-p-0 tw-h-auto tw-w-auto"
                      />
                    </Tooltip>
                  </Popover>
                  <Input
                    ref={inputRef}
                    placeholder={
                      isInputDisabled
                        ? hasOtherClaim
                          ? "Input disabled (Claimed)"
                          : error
                            ? "Input disabled (Error)"
                            : "Input disabled"
                        : "Type a message..."
                    }
                    variant="borderless"
                    bordered={false}
                    disabled={isInputDisabled}
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    style={{
                      border: "none",
                      outline: "none",
                      boxShadow: "none",
                    }}
                    className="tw-flex-1 tw-shadow-none focus:tw-shadow-none focus:tw-outline-none focus:!tw-border-none focus:!tw-ring-0 hover:tw-bg-transparent tw-text-sm tw-font-medium tw-text-sub-text tw-p-0 tw-ml-1 !tw-outline-none !tw-shadow-none !tw-border-none"
                  />
                  <Tooltip title="Send Template">
                    <Button
                      type="text"
                      icon={
                        <FileTextOutlined className="tw-text-[#6b7280] tw-text-[16px]" />
                      }
                      onClick={() => openTemplateManager("Browse Template")}
                      className="tw-flex-shrink-0 hover:tw-bg-transparent !tw-px-0"
                    />
                  </Tooltip>
                  <input
                    type="file"
                    ref={chatFileInputRef}
                    multiple
                    style={{ display: "none" }}
                    onChange={handleChatFileSelect}
                  />
                  <Tooltip title="Attach File">
                    <Button
                      type="text"
                      loading={uploadingChatMedia}
                      icon={
                        <LinkOutlined className="tw-text-[#6b7280] tw-text-[16px]" />
                      }
                      onClick={() =>
                        chatFileInputRef.current &&
                        chatFileInputRef.current.click()
                      }
                      className="tw-flex-shrink-0 hover:tw-bg-transparent !tw-px-0"
                    />
                  </Tooltip>

                  <button
                    type="button"
                    onClick={handleSend}
                    disabled={
                      (!inputValue.trim() && stagedMediaList.length === 0) ||
                      isInputDisabled
                    }
                    className={`tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-white tw-border-none tw-shadow-none tw-flex-shrink-0 tw-outline-none tw-p-0 tw-transition-colors ${
                      (!inputValue.trim() && stagedMediaList.length === 0) ||
                      isInputDisabled
                        ? "tw-bg-gray-300 tw-cursor-not-allowed"
                        : "tw-bg-[#25D366] hover:tw-bg-[#20ba56] tw-cursor-pointer"
                    }`}
                  >
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      className="tw-transform tw-rotate-45 tw-mr-0.5 tw-mt-0.5"
                    >
                      <line x1="22" y1="2" x2="11" y2="13"></line>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                    </svg>
                  </button>
                </div>
              </>
            )}

            {chatStatus === "Awaiting Reply" && (
              <>
                {templates?.filter((t) => t.status === "APPROVED")?.length >
                  0 && (
                  <div className="tw-flex tw-gap-2 tw-mb-3 tw-overflow-x-auto sleek-scrollbar tw-pb-1.5">
                    {templates
                      ?.filter((t) => t.status === "APPROVED")
                      ?.map((template) => (
                        <Tooltip
                          key={template.name}
                          title={renderTemplateTooltip(template)}
                          mouseEnterDelay={0.15}
                        >
                          <div
                            onClick={() => handleTemplateChipClick(template)}
                            className="tw-px-4 tw-py-1.5 tw-bg-[#F0EEFF] tw-text-[#5D44FF] tw-text-xs tw-font-medium tw-rounded-full tw-cursor-pointer tw-whitespace-nowrap hover:tw-bg-[#E5E1FF] tw-border tw-border-solid tw-border-[#DCD7FF]"
                          >
                            📄 {template.name}
                          </div>
                        </Tooltip>
                      ))}
                  </div>
                )}

                <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-text-[#BE9800] tw-font-semibold tw-mb-3 tw-px-1">
                  <span>🔒</span>
                  <span>
                    Chat will activate once you get a reply from the user. You
                    can only send templates currently.
                  </span>
                </div>

                <div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-bg-gray-50 tw-border tw-border-solid tw-border-gray-250 tw-rounded-full tw-px-3.5 tw-py-2 tw-shadow-[0_1px_2px_rgba(0,0,0,0.02)]">
                  <div className="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-min-w-0">
                    <SmileOutlined className="tw-text-[#9ca3af] tw-text-[18px] tw-flex-shrink-0" />
                    <Input
                      placeholder={
                        isInputDisabled
                          ? hasOtherClaim
                            ? "Input disabled (Claimed)"
                            : error
                              ? "Input disabled (Error)"
                              : "Input disabled"
                          : "Type a message..."
                      }
                      variant="borderless"
                      bordered={false}
                      disabled
                      style={{
                        border: "none",
                        outline: "none",
                        boxShadow: "none",
                      }}
                      className="tw-flex-1 tw-shadow-none tw-bg-transparent tw-text-sm tw-font-medium tw-text-gray-400 tw-p-0 tw-ml-1 !tw-outline-none !tw-shadow-none !tw-border-none"
                    />
                  </div>

                  <div className="tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0">
                    <Button
                      type="text"
                      icon={
                        <FileTextOutlined className="tw-text-[#6b7280] tw-text-[16px]" />
                      }
                      onClick={() => openTemplateManager("Browse Template")}
                      className="tw-flex-shrink-0 hover:tw-bg-transparent !tw-px-0"
                      title="Send Template"
                    />
                    <Button
                      type="text"
                      icon={
                        <LinkOutlined className="tw-text-[#6b7280] tw-text-[16px]" />
                      }
                      className="tw-flex-shrink-0 hover:tw-bg-transparent !tw-px-0"
                      title="Attach"
                      disabled
                    />
                    <button
                      type="button"
                      disabled
                      className="tw-w-8 tw-h-8 tw-bg-gray-300 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-white tw-border-none tw-cursor-not-allowed tw-shadow-none tw-flex-shrink-0 tw-outline-none tw-p-0"
                    >
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        className="tw-transform tw-rotate-45 tw-mr-0.5 tw-mt-0.5"
                      >
                        <line x1="22" y1="2" x2="11" y2="13"></line>
                        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                      </svg>
                    </button>
                  </div>
                </div>
              </>
            )}

            {chatStatus === "Re-engage" && (
              <>
                {templates?.filter((t) => t.status === "APPROVED")?.length >
                  0 && (
                  <div className="tw-flex tw-gap-2 tw-mb-3 tw-overflow-x-auto sleek-scrollbar tw-pb-1.5">
                    {templates
                      ?.filter((t) => t.status === "APPROVED")
                      ?.map((template) => (
                        <Tooltip
                          key={template.name}
                          title={renderTemplateTooltip(template)}
                          mouseEnterDelay={0.15}
                        >
                          <div
                            onClick={() => handleTemplateChipClick(template)}
                            className="tw-px-4 tw-py-1.5 tw-bg-[#F0EEFF] tw-text-[#5D44FF] tw-text-xs tw-font-medium tw-rounded-full tw-cursor-pointer tw-whitespace-nowrap hover:tw-bg-[#E5E1FF] tw-border tw-border-solid tw-border-[#DCD7FF]"
                          >
                            📄 {template.name}
                          </div>
                        </Tooltip>
                      ))}
                  </div>
                )}

                <div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-bg-gray-50 tw-border tw-border-solid tw-border-gray-250 tw-rounded-full tw-px-3.5 tw-py-2 tw-shadow-[0_1px_2px_rgba(0,0,0,0.02)]">
                  <div className="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-min-w-0">
                    <SmileOutlined className="tw-text-[#9ca3af] tw-text-[18px] tw-flex-shrink-0" />
                    <Input
                      placeholder={
                        isInputDisabled
                          ? hasOtherClaim
                            ? "Input disabled (Claimed)"
                            : error
                              ? "Input disabled (Error)"
                              : "Input disabled"
                          : "Type a message..."
                      }
                      bordered={false}
                      disabled
                      className="tw-flex-1 tw-shadow-none tw-bg-transparent tw-text-sm tw-font-medium tw-text-gray-400 tw-p-0 tw-ml-1"
                    />
                  </div>

                  <div className="tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0">
                    <Button
                      type="text"
                      icon={
                        <FileTextOutlined className="tw-text-[#6b7280] tw-text-[16px]" />
                      }
                      onClick={() => openTemplateManager("Browse Template")}
                      className="tw-flex-shrink-0 hover:tw-bg-transparent !tw-px-0"
                      title="Send Template"
                    />
                    <Button
                      type="text"
                      icon={
                        <LinkOutlined className="tw-text-[#6b7280] tw-text-[16px]" />
                      }
                      className="tw-flex-shrink-0 hover:tw-bg-transparent !tw-px-0"
                      title="Attach"
                      disabled
                    />
                    <button
                      type="button"
                      disabled
                      className="tw-w-8 tw-h-8 tw-bg-gray-300 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-white tw-border-none tw-cursor-not-allowed tw-shadow-none tw-flex-shrink-0 tw-outline-none tw-p-0"
                    >
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        className="tw-transform tw-rotate-45 tw-mr-0.5 tw-mt-0.5"
                      >
                        <line x1="22" y1="2" x2="11" y2="13"></line>
                        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                      </svg>
                    </button>
                  </div>
                </div>
              </>
            )}

            {chatStatus === "New" && (
              <>
                {templates?.filter((t) => t.status === "APPROVED")?.length >
                  0 && (
                  <div className="tw-flex tw-gap-2 tw-mb-3 tw-overflow-x-auto sleek-scrollbar tw-pb-1.5">
                    {templates
                      ?.filter((t) => t.status === "APPROVED")
                      ?.map((template) => (
                        <Tooltip
                          key={template.name}
                          title={renderTemplateTooltip(template)}
                          mouseEnterDelay={0.15}
                        >
                          <div
                            onClick={() => handleTemplateChipClick(template)}
                            className="tw-px-4 tw-py-1.5 tw-bg-[#F0EEFF] tw-text-[#5D44FF] tw-text-xs tw-font-medium tw-rounded-full tw-cursor-pointer tw-whitespace-nowrap hover:tw-bg-[#E5E1FF] tw-border tw-border-solid tw-border-[#DCD7FF]"
                          >
                            📄 {template.name}
                          </div>
                        </Tooltip>
                      ))}
                  </div>
                )}

                <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-text-sub-text tw-font-semibold tw-mb-3 tw-px-1">
                  <span>Start the conversation with an approved template</span>
                </div>

                <div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-bg-gray-50 tw-border tw-border-solid tw-border-gray-250 tw-rounded-full tw-px-3.5 tw-py-2 tw-shadow-[0_1px_2px_rgba(0,0,0,0.02)]">
                  <div className="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-min-w-0">
                    <SmileOutlined className="tw-text-[#9ca3af] tw-text-[18px] tw-flex-shrink-0" />
                    <Input
                      placeholder={
                        isInputDisabled
                          ? hasOtherClaim
                            ? "Input disabled (Claimed)"
                            : error
                              ? "Input disabled (Error)"
                              : "Input disabled"
                          : "Type a message..."
                      }
                      bordered={false}
                      disabled
                      className="tw-flex-1 tw-shadow-none tw-bg-transparent tw-text-sm tw-font-medium tw-text-gray-400 tw-p-0 tw-ml-1"
                    />
                  </div>

                  <div className="tw-flex tw-items-center tw-gap-2 tw-flex-shrink-0">
                    <Button
                      type="text"
                      icon={
                        <FileTextOutlined className="tw-text-[#6b7280] tw-text-[16px]" />
                      }
                      onClick={() => openTemplateManager("Browse Template")}
                      className="tw-flex-shrink-0 hover:tw-bg-transparent !tw-px-0"
                      title="Send Template"
                    />
                    <Button
                      type="text"
                      icon={
                        <LinkOutlined className="tw-text-[#6b7280] tw-text-[16px]" />
                      }
                      className="tw-flex-shrink-0 hover:tw-bg-transparent !tw-px-0"
                      title="Attach"
                      disabled
                    />
                    <button
                      type="button"
                      disabled
                      className="tw-w-8 tw-h-8 tw-bg-gray-300 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-white tw-border-none tw-cursor-not-allowed tw-shadow-none tw-flex-shrink-0 tw-outline-none tw-p-0"
                    >
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        className="tw-transform tw-rotate-45 tw-mr-0.5 tw-mt-0.5"
                      >
                        <line x1="22" y1="2" x2="11" y2="13"></line>
                        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                      </svg>
                    </button>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>

      <Modal
        title={
          <div className="tw-flex tw-items-center tw-gap-2">
            <FileTextOutlined className="tw-text-[#5D44FF]" />
            <span className="tw-font-bold tw-text-base">
              Send & Preview Template
            </span>
          </div>
        }
        visible={isTemplateModalVisible}
        onCancel={() => setIsTemplateModalVisible(false)}
        onOk={handleSendTemplateClick}
        okText="Send Template"
        width={820}
        destroyOnClose
        centered
      >
        <div className="tw-py-2">
          {templateSendError && (
            <Alert
              message="Sending Failed"
              description={templateSendError}
              type="error"
              showIcon
              className="tw-mb-4"
              closable
              onClose={() => setTemplateSendError(null)}
            />
          )}

          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-6 tw-items-start">
            {/* Left Column: Template Selection & Variable Inputs */}
            <div className="md:tw-col-span-6 tw-flex tw-flex-col tw-gap-4">
              <div>
                <div className="tw-flex tw-justify-between tw-items-center tw-mb-1.5">
                  <label className="tw-text-xs tw-font-bold tw-text-gray-700 tw-uppercase tw-tracking-wider">
                    Select Template
                  </label>
                  <Button
                    type="link"
                    className="!tw-p-0 tw-text-xs tw-font-medium"
                    onClick={() => {
                      setIsTemplateModalVisible(false);
                      if (onCreateTemplate) onCreateTemplate();
                    }}
                  >
                    + Create New Template
                  </Button>
                </div>
                <Select
                  className="tw-w-full"
                  placeholder="Search and select an approved template..."
                  value={selectedTemplateName}
                  onChange={handleTemplateSelection}
                  showSearch
                  size="large"
                  filterOption={(input, option) =>
                    (option?.children || "")
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {templates
                    .filter((t) => t.status === "APPROVED")
                    .map((template) => (
                      <Option key={template.name} value={template.name}>
                        📄 {template.name} ({template.language})
                      </Option>
                    ))}
                </Select>
                {activeChat?.phone && (
                  <div className="tw-text-xs tw-text-gray-500 tw-mt-1.5">
                    Recipient:{" "}
                    <span className="tw-font-medium tw-text-gray-800">
                      {activeChat.name || activeChat.phone}
                    </span>{" "}
                    ({activeChat.phone})
                  </div>
                )}
              </div>

              {/* Variables Section */}
              {selectedTemplateName &&
                (() => {
                  const t = templates.find(
                    (temp) => temp.name === selectedTemplateName,
                  );
                  let comps = [];
                  try {
                    comps =
                      typeof t.components === "string"
                        ? JSON.parse(t.components)
                        : t.components || [];
                  } catch (e) {}
                  const bodyComp = comps.find((c) => c.type === "BODY");
                  const headerComp = comps.find((c) => c.type === "HEADER");

                  const extractVars = (text) => {
                    if (!text) return [];
                    const m = text.match(/\{\{(\d+)\}\}/g);
                    return m
                      ? [...new Set(m.map((x) => x.replace(/[{}]/g, "")))]
                      : [];
                  };

                  const bodyVars = extractVars(bodyComp?.text);
                  const headerVars = extractVars(headerComp?.text);
                  const isMediaHeader =
                    headerComp &&
                    ["IMAGE", "VIDEO", "DOCUMENT"].includes(
                      (headerComp.format || "").toUpperCase(),
                    );

                  if (
                    bodyVars.length === 0 &&
                    headerVars.length === 0 &&
                    !isMediaHeader
                  ) {
                    return (
                      <div className="tw-p-3.5 tw-bg-emerald-50 tw-rounded-xl tw-border tw-border-solid tw-border-emerald-100 tw-text-xs tw-text-emerald-800 tw-flex tw-items-center tw-gap-2">
                        <span>✅</span>
                        <span>
                          This template is ready to send. No variables required.
                        </span>
                      </div>
                    );
                  }

                  const handleMappingChange = (type, v, key, val) => {
                    setTemplateMappings((prev) => {
                      const section = prev[type] || {};
                      const currentMapping = section[v] || {
                        isDynamic: true,
                        attribute: "",
                        value: "",
                      };
                      return {
                        ...prev,
                        [type]: {
                          ...section,
                          [v]: { ...currentMapping, [key]: val },
                        },
                      };
                    });
                  };

                  const renderVariableInput = (type, v) => {
                    const currentMapping = templateMappings[type]?.[v] || {
                      isDynamic: !!activeChat?.clientLeadId,
                      attribute: "",
                      value: "",
                    };
                    return (
                      <div
                        key={`${type}-${v}`}
                        className="tw-bg-white tw-p-3 tw-rounded-lg tw-border tw-border-solid tw-border-gray-200 tw-flex tw-flex-col tw-gap-2"
                      >
                        <div className="tw-flex tw-justify-between tw-items-center">
                          <span className="tw-text-xs tw-font-semibold tw-text-gray-700">
                            {type === "header" ? "Header" : "Body"} Variable{" "}
                            {"{{"}
                            {v}
                            {"}}"}
                          </span>
                          <Select
                            size="small"
                            className="tw-w-32"
                            value={
                              currentMapping.isDynamic ? "dynamic" : "manual"
                            }
                            onChange={(val) =>
                              handleMappingChange(
                                type,
                                v,
                                "isDynamic",
                                val === "dynamic",
                              )
                            }
                          >
                            {activeChat?.clientLeadId && (
                              <Option value="dynamic">Lead Property</Option>
                            )}
                            <Option value="manual">Manual Text</Option>
                          </Select>
                        </div>

                        {currentMapping.isDynamic ? (
                          <Select
                            size="small"
                            className="tw-w-full"
                            placeholder="Select lead property..."
                            value={currentMapping.attribute || undefined}
                            onChange={(val) =>
                              handleMappingChange(type, v, "attribute", val)
                            }
                          >
                            <Option value="firstName">First Name</Option>
                            <Option value="lastName">Last Name</Option>
                            <Option value="company">Company Name</Option>
                            <Option value="email">Email Address</Option>
                            <Option value="phone">Phone Number</Option>
                          </Select>
                        ) : (
                          <Input
                            size="small"
                            className="tw-w-full"
                            placeholder="Enter custom value..."
                            value={currentMapping.value}
                            onChange={(e) =>
                              handleMappingChange(
                                type,
                                v,
                                "value",
                                e.target.value,
                              )
                            }
                          />
                        )}
                      </div>
                    );
                  };

                  return (
                    <div className="tw-bg-indigo-50/60 tw-p-3.5 tw-rounded-xl tw-border tw-border-solid tw-border-indigo-100 tw-flex tw-flex-col tw-gap-3">
                      <div className="tw-text-xs tw-font-bold tw-text-indigo-900 tw-flex tw-items-center tw-gap-1.5">
                        <span>⚙️</span>
                        <span>Configure Template Variables</span>
                      </div>
                      {headerVars.map((v) => renderVariableInput("header", v))}
                      {bodyVars.map((v) => renderVariableInput("body", v))}

                      {isMediaHeader && (
                        <div className="tw-bg-white tw-p-3 tw-rounded-lg tw-border tw-border-solid tw-border-gray-200 tw-flex tw-flex-col tw-gap-2">
                          <span className="tw-text-xs tw-font-semibold tw-text-gray-700">
                            Template Media ({headerComp.format})
                          </span>
                          {selectedTemplateMediaObj ? (
                            <div className="tw-flex tw-items-center tw-justify-between tw-bg-gray-50 tw-p-2 tw-rounded tw-border tw-border-solid tw-border-gray-200">
                              <div className="tw-flex tw-items-center tw-gap-2">
                                <FileOutlined className="tw-text-indigo-500" />
                                <span className="tw-text-xs tw-text-gray-700">
                                  {selectedTemplateMediaObj.fileName}
                                </span>
                              </div>
                              <Button
                                size="small"
                                type="text"
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() =>
                                  setSelectedTemplateMediaObj(null)
                                }
                              />
                            </div>
                          ) : (
                            <Button
                              size="small"
                              type="dashed"
                              className="tw-w-full"
                              onClick={() =>
                                setIsTemplateMediaPickerVisible(true)
                              }
                            >
                              Select {headerComp.format} File
                            </Button>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })()}
            </div>

            {/* Right Column: Standard Live WhatsApp Preview */}
            <div className="md:tw-col-span-6 tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-gray-50 tw-p-4 tw-rounded-2xl tw-border tw-border-solid tw-border-gray-200">
              <div className="tw-text-[11px] tw-font-bold tw-tracking-widest tw-text-gray-400 tw-uppercase tw-mb-3">
                Live Template Preview
              </div>
              {selectedTemplateName ? (
                (() => {
                  const t = templates.find(
                    (temp) => temp.name === selectedTemplateName,
                  );
                  let comps = [];
                  try {
                    comps =
                      typeof t.components === "string"
                        ? JSON.parse(t.components)
                        : t.components || [];
                  } catch (e) {}

                  const sampleValues = computeSampleValues(
                    t,
                    templateMappings,
                    activeChat,
                  );

                  return (
                    <div className="tw-w-full tw-flex tw-justify-center">
                      <TemplatePreview
                        components={comps}
                        sampleValues={sampleValues}
                        compact={true}
                      />
                    </div>
                  );
                })()
              ) : (
                <div className="tw-py-16 tw-text-center tw-text-gray-400 tw-text-xs">
                  Select a template from the left to see live preview
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>

      <MediaPickerModal
        visible={isMediaPickerOpen}
        onClose={() => setIsMediaPickerOpen(false)}
        onSelect={handleMediaSelected}
      />

      <MediaPickerModal
        visible={isTemplateMediaPickerVisible}
        onClose={() => setIsTemplateMediaPickerVisible(false)}
        onSelect={(media) => {
          setSelectedTemplateMediaObj(media);
          setIsTemplateMediaPickerVisible(false);
        }}
        requiredType={
          selectedTemplateName
            ? (() => {
                const t = templates.find(
                  (temp) => temp.name === selectedTemplateName,
                );
                if (!t) return null;
                let comps = [];
                try {
                  comps =
                    typeof t.components === "string"
                      ? JSON.parse(t.components)
                      : t.components || [];
                } catch (e) {}
                const headerComp = comps.find((c) => c.type === "HEADER");
                if (headerComp?.format) {
                  const format = headerComp.format.toUpperCase();
                  if (format === "IMAGE") return "IMAGE";
                  if (format === "VIDEO") return "VIDEO";
                  if (format === "DOCUMENT") return "DOCUMENT";
                }
                return null;
              })()
            : null
        }
      />
    </div>
  );
};

export default ChatWindow;
